import { compose, mdsWidget } from 'dojo/_base/declare';
import arr from 'dojo/_base/array';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import _TemplatedMixin from 'dijit/_TemplatedMixin';
import template from './templates/LoginForm.html?raw';
import topic from 'dojo/topic';
import on from 'dojo/on';
import lang from 'dojo/_base/lang';
import domStyle from 'dojo/dom-style';
import domAttr from 'dojo/dom-attr';
import domConstructTyped from 'dojo/dom-construct';
import domClass from 'dojo/dom-class';
import GenericDialog from '../moreCore/UI/GenericDialog/GenericDialog';
import SimpleFileUpload from '../moreCore/UI/SimpleFileUpload/SimpleFileUpload';
import UserProfileForm from '../WidgetCollection/User/UserProfileForm/UserProfileForm';
// Template-only widgets (data-dojo-type in LoginForm.html, not values in code) → bare imports.
import "./LangSelect";
import "./SubstituteForm";
import "../moreCore/UI/CheckBox/CheckBox";
import "../moreCore/UI/PasswordChange/PasswordChangeHome";
// NOTE (JS2TS): 1:1 port of the legacy classic-dojo-loader widget `more/LoginForm` (kept its module id, so the
// legacy tenant login pages that require("more/LoginForm") keep working — no behavior change). Dropped dead deps
// (dojo/ready, dojo/dom). UserProfileForm import path fixed: original "WidgetCollection/UserProfileForm/..." is
// stale (real file lives under WidgetCollection/User/UserProfileForm/). window-heavy → `w`; DOM-heavy → dom-construct aliased.
declare const require: any; // AMD loader global (used for the async require in _onCloseSessionResponse)
const w: any = window;
const domConstruct: any = domConstructTyped;

class LoginForm extends compose(_WidgetBaseSP, _TemplatedMixin) {
    [key: string]: any;

    templateString: any = template;

    //translations: [],
    pageLinks: any = [];
    redirect: any = null;
    currentSession: any = w.OpenSessionResult;
    sessionID: any = null;
    //sidebar: dijit.registry.byId(this._sidebarWidgetId),

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any)

        this.translations = w.translations;
        this.pageLinks = w.pageLinks;

        this.redirect = this.getUrlParameterValue("redir");
        this.removeUrlParameter("redir");
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.useStandbyManager = true;

        this.handleAutomaticLogin();


        //domAttr.set(this.privacy_text, "innerHTML", this.translations["Impressum__Datenschutz_Checkbox_TXT"]);

    }

    handleAutomaticLogin(): void {
        let encryptedLoginData = this.getUrlParameterValue("encryptedLoginData");

        if (encryptedLoginData == false) {
            return;
        }

        this.removeUrlParameter("encryptedLoginData");

        let uri_decoded_LoginData = w.decodeURIComponent(encryptedLoginData);

        console.log("uri_decoded_LoginData", uri_decoded_LoginData);
        if (uri_decoded_LoginData != null) {

            let url = w.appRoot + "session/open?encryptedData=";

            this.RequestManager.post(url, {
                encryptedData: uri_decoded_LoginData
            },
                lang.hitch(this, this._onOpenSessionResponse),
                lang.hitch(this, this._onOpenSessionError)
            )

        }
    }


    _handleLoginResponse(response: any, reloadLocationIfSuccessful?: any): void {

        //console.log("_handleLoginResponse", response, reloadLocationIfSuccessful, this.RedirectToHomeAction);

        if (response == null) {
            return;
        }
        if (response.Exception == false) {

            //console.log("loginform response", response);

            // Infos anzeigen
            domAttr.set(this.usertext, "innerHTML", response.UserDisplayName);
            domClass.remove(this.userInfoContainer, "w3-hide");

            //window.pageLinks = this.pageLinks;

            this.sessionID = response.Session.Id;

            w.lastLoginResponse = response;

            //var login_message = this.translations["LoginForm__LoginStatusMessage"].format(response.UserDisplayName, response.UserName);
            //this.showMessage(login_message);

            for (var r = 0; r < response.Roles.length; r++) {
                var role = response.Roles[r];
            }

            //console.log("loginform redirect", location.href, this.redirect);
            var redir = this.redirect;
            if (redir != null && redir != "" && redir != false) {
                if (redir.length > 0) {
                    //this.showMessage(this.translations["LoginForm__ForwardingMessage"]);
                    this.showMessage("Redirect...");
                    location.href = w.appRoot + redir;
                    //setTimeout(function () {
                    //    location.reload(); //
                    //}, 1000)

                    return;
                }
            }

            if (reloadLocationIfSuccessful === true) {
                this.showMessage(this.translate("LoginForm__ForwardingMessage"));

                setTimeout(function () {
                    location.reload(); //
                }, 1000)
            } else if (reloadLocationIfSuccessful === false) {
                if (w.sessionInfo) {
                    w.sessionInfo.getProfilepicData(lang.hitch(this, this.setProfilePic));
                }
            } else { // kann auch null sein direkt nach frischem Login -> dann weiter zur Hauptnavigation
                if (!this.hasUserRole("_DEV")) { // sollte man steuerbar machen, will vielleicht nicht jeder Kunde
                    location.href = w.appRoot + "home/start";
                }
            }
        } else {
            this._setStyles();
            if (typeof (response.ErrorMessage) != "undefined") {
                //domAttr.set(this.node_login_error, "innerHTML", response.ErrorMessage);
                this.showMessage(response.ErrorMessage, true);
            }
            //domAttr.set(this.messageNodenode_login_message, "innerHTML", null);
        }


    }

    setProfilePic(data?: any): void {

        //if (data) {
        //    console.debug("loginform setprofilpic", data.checksum);
        //}

        var userIcon = this.iconNode;

        if (userIcon) {
            domConstruct.empty(userIcon);
        }

        if (data) {
            if (userIcon && data.base64) {
                let picOverlay = domConstruct.create("img", {
                    "src": "data:image/jpeg;base64," + data.base64,
                    "className": "profilePic round"
                }, userIcon);
            }
        }
    }

    _onChange_PrivacyCheckbox(): void {
        this._setLoginButtonStyle();
    }

    _setLoginButtonStyle(): void {
        var checked = true;//domAttr.get(this.node_userlogin_privacy_ok, "checked");
        //console.log("privacy: ", checked);
        var value = domAttr.get(this.inputPassword, "value")
        checked = checked && value != null && value != "";

        value = domAttr.get(this.inputUsername, "value")
        checked = checked && value != null && value != "";

        if (checked == true) {
            domAttr.remove(this.btnLogin, "disabled");
            domClass.remove(this.btnLogin, "w3-disabled");
            domClass.add(this.btnLogin, "mds-hover-bright");
        } else {
            domAttr.set(this.btnLogin, "disabled", "disabled");
            domClass.add(this.btnLogin, "w3-disabled");
            domClass.remove(this.btnLogin, "mds-hover-bright");
        }
    }

    _checkProfilePicFeature(): void {
        let bFeature = this.hasFeature("System/UserProfilePic");

        domClass.replace(this.iconNode, "fa-user", "fa-user-circle");

        domClass.toggle(this.iconNode, "noInteraction", !bFeature);
        domClass.toggle(this.iconNode.parentElement, "noInteraction", !bFeature);
        this.hideNode(this.btnProfilePic, !bFeature);
    }

    login_exec(evt?: any): void {

        var privacyChecked: any = true;//domAttr.get(this.node_userlogin_privacy_ok, "checked");
        if (privacyChecked == false) {
            return;
        }

        this._setStyles("loggingIn");
        topic.publish("/Session/Loading", true);

        var inputUsername = this.inputUsername;
        var inputPassword = this.inputPassword;

        this.RequestManager.post(w.appRoot + "session/open", {
            "username": domAttr.get(inputUsername, "value"),
            "password": domAttr.get(inputPassword, "value"),
            "RememberLogin": this.cbRememberLogin.getValue() == true
        },
            lang.hitch(this, "_onOpenSessionResponse"),
            lang.hitch(this, "_onOpenSessionError")
        );

    }
    _onOpenSessionResponse(response: any): void {
        //console.log("loginform _onOpenSessionResponse", response, this.getUrlAction().toLowerCase());
        topic.publish("/Session/Loading", false);
        this.showMessage("");
        topic.publish("/Session/Open", { sessionData: response });//

        let bRedirect = this._checkReload(response);
        if (bRedirect != true) bRedirect = null;

        this._handleLoginResponse(response, bRedirect);

        this._setStyles("loggedIn");
    }

    _onOpenSessionError(error: any): void {
        topic.publish("/Session/Loading", false);
        console.error(error.Message);
        this._setStyles();

        this.showMessage(error.Message, true);
    }

    logout_exec(): void {
        domAttr.set(this.btnLogout, "disabled", "disabled");
        domClass.add(this.userInfoContainer, "w3-hide");

        var sessionID = this.sessionID;

        this._setStyles("loggingOut");

        this.RequestManager.post(w.appRoot + "session/close",
            {
                "sessionid": sessionID
            },
            lang.hitch(this, "_onCloseSessionResponse"),
            lang.hitch(this, "_onCloseSessionError")
        );
    }


    _onCloseSessionResponse(response: any): void {

        this._setStyles("loggedOut");

        this.showMessage(this.translate("LoginForm__LoggedOut"));

        this.sessionID = null;

        (require as any)(["dojo/_base/connect"], function (connect: any) {
            connect.publish("session/close", []);
        });

        topic.publish("/Session/Close", null);

    }

    _onCloseSessionError(error: any): void {

        console.error("_onCloseSessionError", error);

        this._setStyles("loggedIn");
    }

    showMessage(message: any, bError?: any): void {

        if (message == null || message == "" || typeof (message) == "undefined") {
            domClass.add(this.messageNode, "w3-hide");

            message = "";
        } else {
            domClass.remove(this.messageNode, "w3-hide");
        }

        if (bError === true) {
            domClass.add(this.messageNode, "w3-text-red");
        } else {
            domClass.remove(this.messageNode, "w3-text-red");
        }

        domAttr.set(this.messageNode, "innerHTML", message);
    }

    setSubstituteStyle(bActive?: any): void {

        if (typeof (bActive) == "undefined") {
            bActive = w.sessionInfo.isSubstitutionActive() == true;
        }

        console.info("Loginform: Substitute active?", bActive, w.sessionInfo.sessionData);

        var login = w.sessionInfo.sessionData;
        var isSession = w.sessionInfo.isSessionOpen();

        var userName = w.sessionInfo.getUserName();
        var userDisplay = w.sessionInfo.getUserDisplayName();
        var sessionData = w.sessionInfo.sessionData;
        var employeeId = w.sessionInfo.getCurrentEmployeeId();

        if (userDisplay == "" || userDisplay == null || typeof (userDisplay) == "undefined") {
            userDisplay = userName;
        }

        var actualUserName = w.sessionInfo.getUserName(true);
        var actualUserDisplay = w.sessionInfo.getUserDisplayName(true);
        var actualEmployeeId = w.sessionInfo.getCurrentEmployeeId(true);

        domAttr.set(this.substitutetext, "innerHTML", "");

        if (isSession === true) {
            if (bActive === true) {
                //domClass.remove(this.substituteMessageActive, "w3-hide");
                domAttr.set(this.substitutetext, "innerHTML", userDisplay);
            } else {
                domClass.add(this.substituteMessageActive, "w3-hide");
            }

            //domClass.remove(this.substituteContainer, "w3-hide");

        } else {

            //domClass.add(this.substituteContainer, "w3-hide");
        }

    }

    _setStyles(state?: any): void {
        var loginContainer = this.loginContainer;
        var logoutContainer = this.logoutContainer;
        var btnLogout = this.btnLogout;
        var btnLogin = this.btnLogin;
        var loginHeaderContainer = this.loginHeaderContainer;

        this.hideNode(this.loadingArea);

        var login = w.sessionInfo.sessionData;
        //console.debug("Loginform _setStyles", state);

        var actualUserName = w.sessionInfo.getUserName(true);
        var actualUserDisplay = w.sessionInfo.getUserDisplayName(true);
        if (actualUserDisplay == "" || actualUserDisplay == null || typeof (actualUserDisplay) == "undefined") {
            actualUserDisplay = actualUserName;
        }

        domClass.add(this.sectionDeveloper, "hide w3-hide");
        domClass.add(this.userInfoContainer, "w3-hide");

        domClass.remove(this.domNode, "logginOut loggingIn loggedOut loggedIn forwardingAfterLogin");
        domClass.add(this.domNode, state);

        this._checkProfilePicFeature();

        switch (state) {

            case "loggingOut": // gerade beim Logout
                domClass.add(this.domNode, "loggedIn");
                // Logout-Button disablen
                //
                //this.showMessage("logge aus ...");
                domClass.add(btnLogout, "w3-disabled");
                domClass.add(logoutContainer, "w3-disabled");
                //domAttr.set(loginContainer, "disabled", true);
                break;

            default:
            case "loggedOut":
                // ausgeloggt oder noch nicht eingeloggt
                // Loginbox anzeigen und enablen
                // Loginbutton anzeigen und enablen
                //this.showMessage("");
                domClass.remove(loginContainer, "w3-hide w3-disabled");
                domClass.remove(loginHeaderContainer, "w3-hide");
                domClass.add(logoutContainer, "w3-hide");

                domAttr.set(btnLogout, "disabled", false);
                //domClass.remove(btnLogin, "w3-hide");
                domAttr.set(btnLogin, "disabled", false);
                domClass.add(btnLogout, "w3-hide");

                this.setSubstituteStyle(false);

                break;

            case "loggingIn":
                domClass.add(this.domNode, "loggedOut");

                //this.showMessage("wird eingeloggt...");
                domClass.add(loginContainer, "w3-disabled");
                domAttr.set(btnLogin, "disabled", true);
                break;

            case "forwardingAfterLogin":
                // eingeloggt - Seite lädt normal neu
                domClass.add(loginContainer, "w3-hide");
                //domClass.add(btnLogin, "w3-hide");
                domClass.add(loginHeaderContainer, "w3-hide");
                break;

            case "loggedIn":
                //this.showMessage("");
                domClass.add(loginContainer, "w3-hide");
                domClass.add(loginHeaderContainer, "w3-hide");
                domAttr.set(btnLogout, "disabled", false);
                domClass.remove(logoutContainer, "w3-hide w3-disabled");
                domClass.remove(btnLogout, "w3-hide w3-disabled");

                this.setSubstituteStyle();

                domAttr.set(this.usertext, "innerHTML", actualUserDisplay);
                domClass.remove(this.userInfoContainer, "w3-hide");

                if (arr.indexOf(login.Roles, "_DEV") != -1) {
                    domClass.remove(this.sectionDeveloper, "w3-hide hide");
                    if (w.customerSettings) {
                        domAttr.set(this.txtFeatures, "innerHTML", JSON.stringify(w.customerSettings, null, 2));
                    }

                } else {
                    domClass.add(this.sectionDeveloper, "hide w3-hide");
                }

                break;
        }

        this._showHide2FAuthButton();
    }

    _onKeyUp_InputLogin(e: any): void {
        if (e.keyCode == 13) {
            this.login_exec();
        } else {
            this._setLoginButtonStyle();
        }
    }

    checkForExistingSession(): void {

        var data = w.sessionInfo.sessionData;

        //console.log("Loginform checkForExistingSession", data);

        if (this._initialStandbyHandle != null) {
            clearTimeout(this._initialStandbyHandle);
            this._initialStandbyHandle = null;
        }

        domClass.remove(this.loginContainer, "w3-disabled");
        this.hideNode(this.loadingArea);

        this.StandbyStop();

        this._onCheckForExistingSessionResult(data);

    }

    _checkReload(sessionResponse: any): any {
        var bRedirect = false;

        if (sessionResponse != null) {

            if (sessionResponse.Exception == false) {
                bRedirect = arr.indexOf(sessionResponse.Roles, "_DEV") == -1;

                if (bRedirect != true) {
                    console.info("keine Weiterleitung wegen DEV-Rolle!");
                    this.showMessage("Keine Weiterleitung wegen DEV-Rolle!<br><a onclick=\"location.reload();\" href=\"#\">neu laden</a>");
                }

                bRedirect = bRedirect && this.getUrlAction().toLowerCase() != "login";
            }
        }

        return bRedirect;
    }

    _onCheckForExistingSessionResult(response: any): void {
        //domStyle.set(this.loginContainer, "display", "");
        var login = response;//window.lastLoginResponse;
        var state = "";
        var reload = false;

        //console.log("_onCheckForExistingSessionResult", response, this.getUrlAction().toLowerCase(), document.getElementById("loginViewActive"));

        if (login != null && typeof (login) != "undefined") {

            state = "loggedIn";
            //reload = typeof (document.getElementById("loginViewActive")) == "undefined"; //login.IsNewCreated == true;

            reload = this._checkReload(response);

        }

        this._setStyles(state);
        this._handleLoginResponse(response, reload);

    }

    _onCheckForExistingSessionError(error: any): void {
        //domStyle.set(this.loginContainer, "display", "");
        console.error("_onCheckForExistingSessionError", error.Message);
        this.StandbyStop();
        this.hideNode(this.loadingArea);

    }

    _onClick_ReleaseSessionsBtn(): void {
        var url = w.appRoot + "management/ReleaseAllPitSessions";
        this.RequestManager.post(
            url,
            {

            },
            lang.hitch(this, "_onReleaseAllPitSessionsResponse"),
            lang.hitch(this, "_ReleaseAllPitSessionsError"),
            false // sync
        );
    }

    _profilePicUploadData: any = null;

    _onClick_ProfilePic(): void {

        //if (!window.sessionInfo) {
        //    console.warn("cannot change profile pic - sessionInfo is not ready");
        //    return;
        //}

        var dlg: any = new (GenericDialog as any)({
            "header": this.translate("UserProfile__ChangeProfilePic"),
            "content": "",
            "closeOnEnter": false,
            /*"keepOpen": true,*/
            "destroyOnClose": false
        });

        dlg.set("callback", lang.hitch(this, this.profilePicDlgCallback, dlg));

        var container = domConstruct.create("div", { "id": "profilePicDlg" });
        var imageContainer = domConstruct.create("div", { "className": "profilePicContainer empty" }, container);
        var deleteBtnContainer = domConstruct.create("div", { "className": "deleteButtonContainer w3-panel w3-block w3-center" }, container);

        var image = domConstruct.create("img", {
            "src": "",
            "className": "profilePic"
        }, imageContainer);


        var deleteBtn = domConstruct.create("button", {
            "className": "deleteButton mds-button-base round mds-hover-bright tertiaryBG w3-hide",
            "innerHTML": this.translate("General_Remove")
        }, deleteBtnContainer);

        var deleteIcon = domConstruct.create("i", { "className": "fas fa-times deleteIcon" }, deleteBtn, "first");


        //                        <div data-dojo-type="moreCore/UI/SimpleFileUpload/SimpleFileUpload" data-dojo-attach-point="approbationUpload" data-dojo-props="label: 'Main Label Text'"></div>

        var upload: any = new (SimpleFileUpload as any)({ label: 'Main Label Text' });
        domClass.add(upload.domNode, "w3-block w3-panel hidden");
        upload.placeAt(container);
        on(upload, "change", lang.hitch(this, this._serializeProfilePicData, upload, deleteBtn, image, imageContainer, dlg));
        upload.startup();

        on(deleteBtn, "click", lang.hitch(this, this.removeProfilePic, deleteBtn, image, imageContainer, upload, dlg));
        on(imageContainer, "click", lang.hitch(upload, upload.click));

        if (w.sessionInfo) {
            var data = w.sessionInfo.getProfilepicData()
            //console.debug("_onClick_ProfilePic current profiledata", data);
            if (data) {
                if (data.base64) {
                    //setUserdefinedButton(text: string, iconClass: string, callback: Function, bCloseOnClick?: boolean, bSecondaryButton?: boolean)
                    //dlg.setUserdefinedButton("entfernen", "fas fa-trash-alt", lang.hitch(this, this.removeProfilePic), false, true);

                    domClass.remove(imageContainer, "empty");
                    domAttr.set(image, "src", "data:image/jpeg;base64," + data.base64);
                    domClass.remove(deleteBtn, "w3-hide");

                    //var input =
                }
                else {
                    upload.click();
                }
            }
        }


        //dlg.show();
        dlg.show(null, this.translate("UserProfile__ChangeProfilePic"), null, null, "close");
        dlg.addNodeToContent(container);


    }

    _onClick_editProfile(): void {
        //Create new dialog object
        var dlg: any = new GenericDialog();


        dlg.closeOnEnter = false;
        dlg.destroyOnClose = true;
        dlg.keepOpen = true;

        var profileForm: any = new UserProfileForm();

        profileForm.startup();
        profileForm.loadEmployeeData();



        /**domConstruct.create("div", {
            innerHTML: this.translate("TwoFactorAuthenticator__disable2FactorAuth_confirmMessage")
        }, dlg.textNode);
        **/
        dlg.show(profileForm, this.getCurrentUserDisplayName(), null, null, "saveclose", lang.hitch(this, this._onEditProfileDlgResponse, dlg, profileForm));
        dlg.disableButton("save");

        profileForm.on("change", lang.hitch(this, this._onChange_ProfileForm, dlg));
        profileForm.on("saved", lang.hitch(this, this._onSaved_ProfileForm, dlg));
    }

    _onChange_ProfileForm(dlg: any, isDirty: any): void {
        dlg.enableButton("save", isDirty);
    }

    _onEditProfileDlgResponse(dlg: any, form: any, response: any): void {
        if (response >= 1) {
            // save/ok/yes geklickt
            form.saveFormData();
        } else {
            // cancel geklickt
            dlg.close(-1, true);
        }
    }

    _onSaved_ProfileForm(dlg: any): void {
        dlg.close(-1, true);
    }

    _serializeProfilePicData(fileUpload: any, deleteBtn: any, image: any, imageContainer: any, dlg: any): void {
        var data = fileUpload.getUploadData();
        this._profilePicUploadData = data;
        //console.debug("_serializeProfilePicData", data);

        if (data) {
            if (data.files) {
                if (data.files[0].Base64Content) {
                    domAttr.set(image, "src", data.files[0].Base64Content);
                    domClass.add(image, "changed");
                    domClass.remove(imageContainer, "empty");
                    domClass.remove(deleteBtn, "w3-hide");
                }
            }
        }



        dlg.set("closeBtn", false);
        dlg.set("cancelBtn", true);
        dlg.set("okBtn", true);
    }

    profilePicDlgCallback(dlg: any, result: any): void {
        //console.debug("profilePicDlgCallback", result);

        if (result >= 1) {
            //domClass.add(dlg.domNode, "w3-disabled");
            this.uploadProfilePic(dlg);
        } else {
            dlg.destroy();
        }
    }
    removeProfilePic(deleteBtn: any, image: any, imageContainer: any, upload: any, dlg: any, evt?: any): void {
        if (evt) {
            evt.stopPropagation();
        }

        upload.reset();

        //console.debug("removeProfilePic");
        domClass.add(deleteBtn, "w3-hide");
        domAttr.set(image, "src", "");
        domClass.add(imageContainer, "empty");

        this._profilePicUploadData = null;

        dlg.set("closeBtn", false);
        dlg.set("cancelBtn", true);
        dlg.set("okBtn", true);
    }

    uploadProfilePic(dlg: any): void {

        let url = w.appRoot + "Home/UploadWebuserProfilePic";

        var data = { "webuserID": w.sessionInfo.getCurrentWebuserId(), "data": this._profilePicUploadData };

        this.RequestManager.post(url,
            {
                "jsonData": JSON.stringify(data)
            },
            lang.hitch(this, this._onUploadProfilePicResponse, dlg),
            lang.hitch(this, this._onUploadProfilePicError, dlg)
        )
    }

    _onUploadProfilePicResponse(dlg: any, response: any): void {
        this.StandbyStop();

        dlg.destroy();

        this.StandbyStart();

        w.sessionInfo.checkForExistingSession();
    }

    _onUploadProfilePicError(dlg: any, error: any): void {
        alert("error uploading profile pic:\r\n" + error.Message);

        //domClass.remove(dlg.domNode, "w3-disabled");
        dlg.show();

        this.StandbyStop();
    }

    _onReleaseAllPitSessionsResponse(result: any): void {
        alert(result);
    }

    _ReleaseAllPitSessionsError(error: any): void {
        console.error("Release Error", error);
    }

    _onClick_CurrentXXX(evt?: any): void {
        var jsonData = "";

        var url = w.appRoot + "management/GetCurrentXXX";
        this.RequestManager.post(
            url,
            {
                "jsonData": jsonData
            },
            lang.hitch(this, "_devDisplayResult"),
            lang.hitch(this, "_devDisplayResult"),
            false // sync
        );
    }

    _onClick_ToggleRoleDebug(): void {
        let currentState = false;

        try {
            let data = JSON.parse(localStorage.getItem("ego_DebugUserroles"));
            currentState = data.state === true && data.userName == w.sessionInfo.getUserName();
        } catch (ex) {

        }

        currentState = !currentState;

        localStorage.setItem("ego_DebugUserroles", JSON.stringify({ state: currentState, userName: w.sessionInfo.getUserName() }));

        alert("debugging set to " + currentState.toString() + "; check console for results while testing");
    }

    _onClick_ToggleDarkMode(): void {
        if (!this.hasFeature("System/darkMode") && !this.hasFeature("System/lightMode")) {
            return;
        }

        this._toggleTheme();
    }
    _onClick_ToggleDarkModeDebug(): void {
        if (!this.hasUserRole("_DEV")) {
            return;
        }

        this._toggleTheme();
    }

    _toggleTheme(): void {
        topic.publish("Theme/RequestChange");
    }

    _onThemesAvailable(): void {
        this.hideNode(this.darkModeContainer, false);
    }

    _onSetTheme(targetTheme: any): void {

        this.btnDarkmodeToggle.innerHTML = this.createFontawesomeIcon(targetTheme == "dark" ? "fas fa-sun" : "fas fa-moon").outerHTML;
        domClass.toggle(this.btnDarkmodeToggle, "cL2", targetTheme == "dark");
        domClass.toggle(this.btnDarkmodeToggle, "cD1", targetTheme == "light");
    }

    _devDisplayResult(response: any): void {
        alert(response);
    }

    _onClick_setUp2FAuth(): void {
        location.href = w.appRoot + "home/TwoFactorAuthentication";
    }

    _onClick_disable2FAuth(): void {

        var dlg: any = new GenericDialog();

        dlg.closeOnEnter = false;
        dlg.destroyOnClose = true;
        dlg.set("topCloseBtn", true);
        dlg.set("cancelBtn", true);

        domStyle.set(dlg.modalDlgContentNode, "margin-top", "10%");

        domConstruct.create("div", {
            innerHTML: this.translate("TwoFactorAuthenticator__disable2FactorAuth_confirmMessage")
        }, dlg.textNode);

        domConstruct.create("input", {
            className: "w3-input w3-border w3-border-gray",
            style: {
                width: "300px"
            },
            id: "twoFactorAuthCodeInput",
            onkeyup: lang.hitch(this, function (this: any, evt: any) {
                let input: any = document.getElementById("twoFactorAuthCodeInput");
                this.twoFactorAuthCode = input.value;
            })
        }, dlg.textNode);

        dlg.setUserdefinedButton(this.translate("TwoFactorAuthentication__dlgSubmitButton"), null, lang.hitch(this, "_disable2FAuth"), true);
        dlg.show();

    }

    _disable2FAuth(): void {
        if (this.twoFactorAuthCode != null && this.twoFactorAuthCode != "" && this.twoFactorAuthCode.length == 6) {
            this.RequestManager.post(
                w.appRoot + "Session/DisableTwoFactorAuthentication",
                {
                    token: this.twoFactorAuthCode
                },
                lang.hitch(this, "_onDisable2FAuthResponse"),
                lang.hitch(this, "_onDisable2FAuthError"),
                false // sync
            );
        } else {
            alert(this.translate("TwoFactorAuthentication__dlgInvalidCodeMessage"));
        }
    }

    _onDisable2FAuthResponse(response: any): void {
        if (response == "success") {
            alert(this.translate("TwoFactorAuthenticator__disable2FactorAuth_successMessage"));
            location.reload();
        } else if (response.Message) {
            alert(response.Message);
        } else {
            console.error(response);
        }
    }

    _onDisable2FAuthError(err: any): void {

        if (err != "success" && err.Message != "success") {
            if (err && err.Message) alert(err.Message);
            console.error(err);
        } else {
            this._onDisable2FAuthResponse("success");
        }
    }

    _showHide2FAuthButton(): void {
        if (w.sessionInfo && w.sessionInfo.sessionData) {
            // button is hide by default - if 2F is enabled - show it
            if (w.sessionInfo.sessionData.IsTwoFactorAuthEnabled == true) {
                domClass.remove(this.EnableTwoFAuthButton, "w3-hide");
            }
            // if user is 2f authenticated - he does not need the button
            if (w.sessionInfo.sessionData.IsValidTwoFactorAuthentication == true) {
                domClass.add(this.EnableTwoFAuthButton, "w3-hide");
            }
            // show disable 2fauth button
            if (w.sessionInfo.sessionData.IsValidTwoFactorAuthentication == true &&
                w.sessionInfo.sessionData.IsTwoFactorAuthRequired == true &&
                w.sessionInfo.sessionData.IsTwoFactorAuthEnabled == true) {
                domClass.remove(this.DisableTwoFAuthButton, "w3-hide");
            } else {
                domClass.add(this.DisableTwoFAuthButton, "w3-hide");
            }
        }
    }

    _setupSubscriptions(): void {
        //this._topics.push(topic.subscribe("/Session/Open", lang.hitch(this, this._onOpenSession))); //
        this._topics.push(topic.subscribe("/Session/CheckForExistingSession", lang.hitch(this, this.checkForExistingSession)));
        this._topics.push(topic.subscribe("/Session/SubstituteActive", lang.hitch(this, this.setSubstituteStyle)));
        this._topics.push(topic.subscribe("Theme/Change", lang.hitch(this, this._onSetTheme)));
        this._topics.push(topic.subscribe("Theme/ToggleAvailable", lang.hitch(this, this._onThemesAvailable)));

        //this._topics.push(topic.subscribe("/Session/Close", lang.hitch(this, this._onCloseSession)));
    }

    _initialStandbyHandle: any = null;

    _onClick_CheckFeature(evt?: any): void {
        let featurepath = this.inputFeaturepath.value;
        if (featurepath) {
            let result = this.hasFeature(featurepath);
            alert(featurepath + ": " + result.toString());
        }
    }
    startup(): void {
        super.startup.apply(this, arguments as any);

        this._initialStandbyHandle = setTimeout(lang.hitch(this, this.StandbyStart), 1);

        if (w.showLanguageSelector === false || w.showLanguageSelector === true) {
            domClass.toggle(this.langSelect.domNode, "w3-hide", !w.showLanguageSelector);
        }

        if (this.hasFeature("System/PasswordReset")) this.hideNode(this.resetPasswordContainer, false);

        //this.checkForExistingSession();

        //this.btnLogin.innerHTML = this.translations.LoginForm__Username...
    }

}
LoginForm.prototype.declaredClass = 'more.LoginForm';

export default mdsWidget(LoginForm);
